export default {
  PRICE_PREPROCESSING_ID: 'ce0031f8-b206-4e8c-97b4-2dc73f1eab84',
  FEATURE_GEO_RESTRICTION_ID: '746c0f7f-4e0d-4814-8f4f-9b10420c30e7',
  FEATURE_PRE_POST_PROCESSING_ID: 'd9247f73-9d5a-4e05-98c1-cb9d9f052aa7',
  FEATURE_WIZARD2_VERSION_ID: 'ee9de67e-565c-494f-8fa5-aaa1616707aa',
  FEATURE_RESTRICTED_FILE_TYPES_ID: '3a66829d-8781-4bf8-b543-3d1aadafc3b5',
  INCORRECT_USER_TEXT: 'You\'re not logged in with the correct account for this payment link. Please log in with the appropriate account or contact support for help.'
};
